import { Quota } from '../objects/quota';
import { Config } from '../objects/config';

export const SET_CONFIG = 'HEADER_SET_CONFIG';
export const SET_GOOGLE = 'HEADER_SET_GOOGLE';
export const UPDATE_QUOTA = 'HEADER_UPDATE_QUOTA';

interface SetConfigAction {
    type: typeof SET_CONFIG,
    payload: Config
}

interface SetGoogleAction {
    type: typeof SET_GOOGLE,
    payload: any
}

interface UpdateQuotaAction {
    type: typeof UPDATE_QUOTA,
    payload: Quota
}

export type HeaderActionTypes =
    SetConfigAction |
    SetGoogleAction |
    UpdateQuotaAction;